export function getRelatedCaseStudies({ caseStudies = [], currentId }) {
    const filtered = (caseStudies || []).filter(cs => !cs?.draft && !cs?.deletedAt);
    if (!filtered.length) return [];

    const sorted = [...filtered].sort((a, b) => {
        const orderA = a?.order ?? Number.MAX_SAFE_INTEGER;
        const orderB = b?.order ?? Number.MAX_SAFE_INTEGER;
        if (orderA !== orderB) return orderA - orderB;
        return (a?.name || "").localeCompare(b?.name || "");
    });

    if (!currentId) return sorted.slice(0, 3);

    const currentIndex = sorted.findIndex(
        cs => cs?.shortId === currentId
    );
    if (currentIndex === -1) return sorted.slice(0, 3);

    const limit = Math.min(3, Math.max(0, sorted.length - 1));
    const result = [];
    for (let i = 1; i <= limit; i += 1) {
        result.push(sorted[(currentIndex + i) % sorted.length]);
    }
    return result;
}
